// extracted by mini-css-extract-plugin
export default {"root":"_2acux","title":"_11bl-","subTitle":"ue6Qy","liveLabel":"_3lDDb","errorBox":"_5pWST","errorTitle":"_1w5TG","errorLink":"_1DCwc"};